



















































import Vue from 'vue';
import ResponsePagingInfo from '../../../../plugins/servicelayer/responseTypes/responsePagingInfo';
import GetIntegrationCallsRequestViewModel from '../../../../services/viewModel/request/IntegrationCalls/GetIntegrationCallsRequestViewModel';
import IntegrationTaskResourceViewModel from '../../../../services/viewModel/resource/IntegrationTaskResourceViewModel';

export default Vue.extend({
  auth: true,
  role: ['admin', 'hostadmin'],
  layout: 'layout-hostadmin',
  data: () => ({
    requestError: undefined as any,
    pagination: {} as ResponsePagingInfo,
    filter: {
      searchCriteria: undefined as string | undefined,
      integrationTaskId: undefined as number | undefined,
      integrationStatusId: undefined as number | undefined,
      dateFrom: undefined as string | undefined,
      dateTo: undefined as string | undefined,
    },
    innerPagination: {
      'paging.CurrentPage': undefined as number | undefined,
      'paging.PageSize': undefined as number | undefined,
      'paging.IncludeCount': undefined as boolean | undefined,
      'paging.NoPaging': undefined as boolean | undefined,
    },
    list: {},
    columns: [] as {}[],
    events: [
      { caption: 'Unknown', id: 0 },
    ],
    statuses: [
      { caption: 'Pending', id: 0 },
      { caption: 'In Progress', id: 1 },
      { caption: 'Success', id: 2 },
      { caption: 'Error', id: 3 },
      { caption: 'Completed', id: 4 },
    ],
    integrationTasks: [] as IntegrationTaskResourceViewModel[],
  }),
  computed: {
    request() {
      return new GetIntegrationCallsRequestViewModel().fromModel({ ...this.filter, ...this.innerPagination });
    },
    querySearchCriteria(): string {
      return this.$router.currentRoute.query.searchCriteria as string;
    },
    queryDateTo(): string {
      return this.$router.currentRoute.query.dateTo as string;
    },
    queryDateFrom(): string {
      return this.$router.currentRoute.query.dateFrom as string;
    },
    queryTaskId(): string {
      return this.$router.currentRoute.query.taskId as string;
    },
    queryStatusId(): string {
      return this.$router.currentRoute.query.statusId as string;
    },
    queryCurrentPage(): string {
      return this.$router.currentRoute.query.currentPage as string;
    },
    queryPageSize(): string {
      return this.$router.currentRoute.query.pageSize as string;
    },
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        this.pagination.currentPage = 1;
        this.innerPagination['paging.CurrentPage'] = 1;
        this.$debounce(() => {
          this.refresh();
        }, 300, this)();
      },
    },
    request() {
      this.writeRequestToQuery();
    },
  },
  beforeMount() {
    this.getQueryFromRequest();
    this.pagination.currentPage = this.innerPagination['paging.CurrentPage'] !;
    this.pagination.pageSize = this.innerPagination['paging.PageSize'] !;
  },
  mounted() {
    this.columns = [
      { value: '', field: 'filter' },
      { value: this.$t('core.page.integrationlog.list.id'), field: 'id' },
      {
        value: this.$t('core.page.integrationlog.list.created'), field: 'created', width: '200px', format: (value: string) => this.$date(value).format('DD.MM.YYYY HH:mm:ss:SSS'),
      },
      { value: this.$t('core.page.integrationlog.list.task'), field: 'integrationTaskName' },
      { value: this.$t('core.page.integrationlog.list.source'), field: 'sourceAppSystemName' },
      {
        value: this.$t('core.page.integrationlog.list.subject'), field: 'integrationObjectSummary', format: (value : any) => this.$format.ellipsis(value, 140),
      },
      { value: this.$t('core.page.integrationlog.list.status'), field: 'integrationStatusName' },
      {
        value: this.$t('core.page.integrationlog.list.message'), field: 'integrationStatusMessage', width: '280px', format: (value: string) => this.$format.ellipsis(value, 140),
      },
    ];
    this.getIntegrationTasks();
  },
  methods: {
    getQueryFromRequest() {
      const queryParams = new GetIntegrationCallsRequestViewModel();
      queryParams.fromQuery(this.$routerUtils.getQueryParams());
      this.filter.searchCriteria = queryParams.searchCriteria;
      this.filter.integrationTaskId = queryParams.integrationTaskId;
      this.filter.integrationStatusId = queryParams.integrationStatusId;
      this.filter.dateFrom = queryParams.dateFrom;
      this.filter.dateTo = queryParams.dateTo;

      this.innerPagination['paging.CurrentPage'] = queryParams['paging.CurrentPage'];
      this.innerPagination['paging.PageSize'] = queryParams['paging.PageSize'];
      this.innerPagination['paging.IncludeCount'] = queryParams['paging.IncludeCount'];
      this.innerPagination['paging.NoPaging'] = queryParams['paging.NoPaging'];
    },
    async writeRequestToQuery() {
      this.$debounce(() => {
        this.$routerUtils.updateQueryParams(this.request.toQuery(), { preserve: false });
      }, 200, this.writeRequestToQuery)();
    },
    refresh() {
      const ordersList = this.$refs.ordersList as any;
      ordersList?.populateList();
    },
    populateData(params: any) {
      this.innerPagination['paging.CurrentPage'] = params.query['paging.CurrentPage'];
      this.innerPagination['paging.PageSize'] = params.query['paging.PageSize'];
      this.innerPagination['paging.IncludeCount'] = params.query['paging.IncludeCount'];
      this.innerPagination['paging.NoPaging'] = params.query['paging.NoPaging'];
      return this.$service.api.core.integrationCalls.getIntegrationCalls(this.request);
    },
    async getIntegrationTasks() {
      try {
        const response = await this.$service.api.core.integrationTasks.getIntegrationTasks();
        this.integrationTasks = response.items;
      } catch (error: any) {
        this.requestError = error;
      }
    },
  },
});
